export default __webpack_public_path__ + "static/media/Coding Resume 2021 PDF.f6900c31.pdf";